// ------------------------------------
// Zoom
// ------------------------------------
(function () {
  'use strict';
  $('.img-zoom').zoom();
})();
